<script>
  const updateAppBadge = (notifications) => {
    if (navigator.setAppBadge) {
      if (notifications.length) {
        navigator.setAppBadge(notifications.length);
        setFaviconBadge(notifications.length);
      } else {
        clearFaviconBadge();
        navigator.clearAppBadge();
      }
    }
  };

  const setFaviconBadge = (count) => {
    const favicon = document.querySelector('[type="image/x-icon"]');

    if (!favicon) {
      return;
    }

    const size = 64;
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');

    canvas.width = size;
    canvas.height = size;

    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.src = favicon.href;

    img.onload = () => {
      context.drawImage(img, 0, 0, size, size);

      context.beginPath();
      context.arc(48, 16, 16, 0, 2 * Math.PI);
      context.fillStyle = 'red';
      context.fill();

      context.font = 'bold 24px Arial';
      context.fillStyle = 'white';
      context.textAlign = 'center';
      context.textBaseline = 'middle';
      context.fillText(count > 99 ? '99+' : count, 48, 16);

      favicon.href = canvas.toDataURL('image/png');
    };
  };

  const clearFaviconBadge = () => {
    const favicon = document.querySelector('[type="image/x-icon"]');
    favicon.href = 'https://opensense-ui-assets.s3.amazonaws.com/emblem.png';
  };

  /**
   * An array of notification objects
   * @type {Array<{*}>}
   * @default []
   */
  export let notifications = [];

  $: notifications?.length, updateAppBadge(notifications);
</script>
